import { DIGITAL_ARCHIVE_PAGES } from './pages'
import { DIGITAL_ARCHIVE_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const DIGITAL_ARCHIVE_MODULE = {
  NAME: 'archive',
  NAME_PTBR: 'Acervo Digital',
  UPPER_NAME: 'ARCHIVE',
  API_NAME: 'ARCHIVE',
  PAGES: DIGITAL_ARCHIVE_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: DIGITAL_ARCHIVE_PAGES_ORDER_FOR_PERMISSIONS,
}
